import { AppBar, Box, Stack, Toolbar, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { logoSrc } from 'assets/images'

import { HelpCenterLink } from './help-center-link/HelpCenterLink'
import { LanguageSelector } from './language-selector/LanguageSelector'
import { ProfileMenu } from './profile-menu/ProfileMenu'

export type ApplicationBarProps = Readonly<{
  backgroundColor: string
}>

const Logo = () => {
  const { t } = useTranslation()
  return (
    <Stack
      direction="row"
      alignItems="center"
      component={Link}
      spacing={2}
      to="/"
      sx={{ textDecoration: 'none' }}
    >
      <img src={logoSrc} alt="Home" height={52} />
      <Typography variant="button" color="secondary.main">
        {t('applicationBar.menu.admin')}
      </Typography>
    </Stack>
  )
}

export const ApplicationTopBar: React.FC<ApplicationBarProps> = ({ backgroundColor }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: 3,
      }}
      data-testid="application-bar"
    >
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'unset',
          justifyContent: 'space-between',
          overflow: 'overlay',
        }}
      >
        <Logo />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0 20px' }}>
          <HelpCenterLink />
          <LanguageSelector backgroundColor={backgroundColor} />
          <ProfileMenu backgroundColor={backgroundColor} />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
